import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import {useNavigate} from 'react-router-dom';


import * as errorBoundaryConstants from './errorBoundaryConstants';
import * as i18nUtils from '../../../utils/i18nUtils';

import config from '../../../config';

import Logo from '../../../public/images/logo.svg';
import {Container} from '../../layouts';
import {staticConstants} from '../../modules/Static';

import styles from './ErrorBoundary.scss';


function ErrorBoundary({children}) {

    const navigate = useNavigate();
    const baseLocale = i18nUtils.detectBaseLocale();
    const {ERROR_TEXTS_BY_BASE_LOCALE} = errorBoundaryConstants;
    const texts = ERROR_TEXTS_BY_BASE_LOCALE.hasOwnProperty(baseLocale)
        ? ERROR_TEXTS_BY_BASE_LOCALE[baseLocale]
        : ERROR_TEXTS_BY_BASE_LOCALE[errorBoundaryConstants.FALLBACK_BASE_LOCALE];

    return (
        <Sentry.ErrorBoundary
            fallback={({error, eventId, componentStack, resetError}) => {

                return (
                    <Container>
                        <div className={styles.errorBoundary}>

                            <Logo/>

                            <h2>
                                {texts.headline}
                            </h2>
                            <p>
                                {texts.text1}
                            </p>
                            <p>
                                {texts.text2}
                            </p>
                            <p className={styles.eventId}>
                                Event-ID: {eventId}
                            </p>

                            {config.environment.isDevelopment && (
                                <>

                                    <h3>Error</h3>
                                    <pre>
                                        {error.stack}
                                    </pre>

                                    <h3>Stack</h3>
                                    <pre>
                                        {componentStack}
                                    </pre>

                                </>
                            )}

                            <button
                                aria-label={texts.buttonResetLabel}
                                onClick={() => resetError()}
                                type={'button'}
                            >
                                {texts.buttonResetLabel}
                            </button>
                        </div>
                    </Container>
                );
            }}
            onReset={() => navigate(staticConstants.NAV_HOME)}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
}


ErrorBoundary.propTypes = {
    children: PropTypes.any
};

ErrorBoundary.defaultProps = {};


export default ErrorBoundary;
